import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { MSG } from 'commons/constants';
import { message } from 'antd';

interface MailTemplateCodeprops {
  params: MailTemplateCodeListReqDto;
}

const useMailTemplateCode = ({params}: MailTemplateCodeprops) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [codeList, setCodeList] = useState<UserCodeListDto[]>();

  const {  } = useQuery(
    [endpoints.refcode.mail.codelist, params],
    () =>
      fetcher.refcode.getMailCodeList(params),
    {
      enabled: !!params.mail_type && params.mail_type !== '',
      onSuccess: (res: UserCodeListResDto) => {
        switch (res.code) {
          case 200:
            setCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { codeList  };
};

export default useMailTemplateCode;
